// src/components/Utils.jsx

// Helper to decode a string to base64-url
export const decodeBase64Url = (encodedString) => {
  const base64 = encodedString.replace(/-/g, '+').replace(/_/g, '/');
  const decodedString = atob(base64);
  return decodedString;
};

// Helper to encode a string to base64-url
export const encodeBase64Url = (string) => {
  const base64 = btoa(string);
  const base64Url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  return base64Url;
};

// Helper to sort submodel descriptors by a given reference order
export const sortSubmodelDescriptorsByOrderReference = (submodelDescriptors, orderReference) => {
  const orderMap = new Map(orderReference.map((id, index) => [id, index]));
  return [...submodelDescriptors].sort((a, b) => {
    const aIndex = orderMap.has(a.idShort) ? orderMap.get(a.idShort) : Infinity;
    const bIndex = orderMap.has(b.idShort) ? orderMap.get(b.idShort) : Infinity;
    return aIndex - bIndex;
  });
};

// Helper to sort submodels by a given reference order
export function sortSubmodels(submodels, orderReference) {
  if (!Array.isArray(submodels)) return submodels;

  return sortSubmodelDescriptorsByOrderReference(
    submodels.map(sm => ({ idShort: sm.idShort, ref: sm })),
    orderReference
  ).map(x => x.ref);
}

// Helper to find a submodel descriptor by idShort
export const findSubmodelDescriptorByIdShort = (submodelDescriptors, idShort) => {
  console.log('submodel descriptors for findSubmodelDescriptorByIdShort:', submodelDescriptors);
  if (!submodelDescriptors || !Array.isArray(submodelDescriptors) || !idShort) {
    return undefined;
  }
  return submodelDescriptors.find((descriptor) => descriptor.idShort === idShort);
};

/**
 * Universal helper to extract the best display text from AAS multi-language values
 * Works with:
 *   - plain string
 *   - { text: "..." }
 *   - [{ language: "en", text: "..." }, ...]
 *
 * @param {any} value - The value from the AAS (can be string, object, array)
 * @param {string} fallback - What to return if nothing found (default: "N/A")
 * @param {string} locale - Optional locale (e.g. "en", "de"). If not provided, falls back to first entry
 * @returns {string}
 */
const getLocalizedText = (value, fallback = "N/A", locale = null) => {
  // 1. Null/undefined → fallback
  if (value === null || value === undefined) {
    return fallback;
  }

  // 2. Plain string → return as-is
  if (typeof value === "string") {
    return value.trim() || fallback;
  }

  // 3. Array → multi-language property
  if (Array.isArray(value) && value.length > 0) {
    // If locale is provided, try to match it (case-insensitive)
    if (locale) {
      const normalizedLocale = locale.toLowerCase();
      const matched = value.find(
        (item) => item?.language?.toLowerCase() === normalizedLocale
      );
      if (matched?.text?.trim()) {
        return matched.text.trim();
      }
    }

    // Fallback: return first entry's text
    const firstText = value[0]?.text;
    return firstText?.trim() || fallback;
  }

  // 4. Simple object like { text: "..." }
  if (typeof value === "object" && value.text !== undefined) {
    return value.text?.trim() || fallback;
  }

  // 5. Anything else → convert to string as last resort
  return String(value)?.trim() || fallback;
};

export default getLocalizedText;